// servizi/spiegazioni.ts — v038: la spiegazione del torneo e della partita a 4 si vede una volta sola (poi sta
// nell'aiuto e nel tutorial). Una volta toccato «Crea», la volta dopo si crea subito.
import { leggiPreferenza, salvaPreferenza } from "./preferenze.ts";
import { PREFERENZE } from "../costanti.ts";
import { vistiCambiati } from "./account.ts";

export type Spiegazione = "torneo" | "gruppo";

function lette(): Record<string, boolean> {
  try {
    const v = JSON.parse(leggiPreferenza(PREFERENZE.spiegazioniViste) ?? "{}") as unknown;
    return v && typeof v === "object" ? (v as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}
export const spiegazioneVista = (k: Spiegazione): boolean => lette()[k] === true;
export function segnaSpiegazione(k: Spiegazione): void {
  salvaPreferenza(PREFERENZE.spiegazioniViste, JSON.stringify({ ...lette(), [k]: true }));
  vistiCambiati(); // v041: anche sull'account (altri telefoni, incognito)
}
